import React from 'react';
import { Filter, TextInput, SelectInput, useTranslate } from 'react-admin';
import { List } from '~/layout';
import {
  DateTimeInput,
  ReferenceInput,
  KycLevelSelect,
  ProfileTagsFilterInput,
  AllPaymentInstrumentsSelect,
} from '~/components/ra';
import { PricingDatagrid } from '../solutions/components/Pricing/PricingDatagrid';
import { useDefaultListFilterStyles } from '~/hooks/useListFilterStyles';

const PricingFilters = (props: any) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.solutions.pricings.${key}`);
  const td = (key: string): string => translate(`utils.${key}`);
  const classes = useDefaultListFilterStyles();
  return (
    <Filter {...props} className={classes.form}>
      <TextInput className={classes.formControl} label={t('name')} source='name' alwaysOn />
      <ReferenceInput
        className={classes.formControl}
        source='solutionId'
        reference='solutions'
        allowEmpty
        emptyText={td('any')}
        alwaysOn
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      <KycLevelSelect
        className={classes.formControl}
        label={t('kycLevel')}
        source='kycLevel'
        alwaysOn
      />
      <DateTimeInput
        className={classes.formControl}
        source='activeFrom'
        label={t('activeFrom')}
        options={{ format: 'LL LT', clearable: true }}
        fullWidth
        alwaysOn
      />
      <AllPaymentInstrumentsSelect
        source='paymentInstrument'
        label={t('paymentInstrument')}
        className={classes.formControl}
        emptyText={td('any')}
        alwaysOn
      />
      <ProfileTagsFilterInput
        label={t('profileTags')}
        className={classes.formControlLong}
        alwaysOn
      />
    </Filter>
  );
};

const PricingList = (props: any) => {
  return (
    <List
      bulkActionButtons={false}
      filters={<PricingFilters />}
      {...props}
      sort={{ field: 'name', order: 'ASC' }}
    >
      <PricingDatagrid rowClick='show' size='medium' />
    </List>
  );
};

export default PricingList;
